<template>
    <button class="btn btn-info me-1 mt-4" type="button" @click="openModal">
        Upload From Your Phone
    </button>
    <div class="modal fade" id="photo-upload-qr-modal" tabindex="-1">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Scan the QR Code</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeModal"></button>
                </div>
                <div class="modal-body">
                    <div>
                        Images will take a few seconds to appear on screen
                    </div>
                    <div class="qr-container" v-if="!message">
                        <div class="qr-code">
                            <img width="200" height="200" alt="QR Code" :src=qrCode />
                        </div>
                    </div>
                    <QrUploadList
                        :token="token"
                        :onQrUploads="addFilesFromQr"
                        :isPolling="isPolling"
                        v-if="isPolling"
                    />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="closeModal">Finish</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.qr-container {
    display: flex;
    justify-content: center;
}
</style>
<script>
import QrUploadList from '@/components/QrUploadList.vue';
import { Modal } from 'bootstrap';
import api from '@/services/api';

export default {
    props: {
        modelValue: {
            required: true,
        },
        v: {
            required: true,
        },
    },
    data() {
        return {
            token: null,
            qrCode: null,
            loading: false,
            message: null,
            allUploads: this.modelValue,
            qrUploads: [],
            isPolling: false,
        }
    },
    emits: ['update:modelValue'],
    methods: {
        openModal: async function () {
            this.modal = new Modal(document.getElementById('photo-upload-qr-modal'));
            this.modal.show();
            await this.getQrAndToken();
            this.isPolling = true;
        },
        closeModal: function () {
            this.isPolling = false;
            this.modal.hide();
        },
        getQrAndToken: async function () {
            this.loading = true;
            try {
                const res = await api.get('/api/v1/qr/generate');
                this.token = res.data.token;
                this.qrCode = res.data.qrCode;
            } catch (e) {
                this.message = e.message;
                this.token = null;
            }
            this.loading = false
        },
        addFilesFromQr: function (uploads) {
            uploads = uploads.filter((upload) => {
                const allUploadIds = this.allUploads.map((aU) => aU.id);
                return allUploadIds.includes(upload.id) ? false : true;
            })
            uploads.forEach((upload) => {
                upload.processed = true;
                upload.name = upload.file_name;
                upload.isFromQr = true;
            });
            this.allUploads = [...this.allUploads, ...uploads];
            this.$emit('update:modelValue', this.allUploads);
        }
    },
    components: {
        QrUploadList,
    },
}
</script>